import { QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";

import { createQueryClient } from "@/lib/query-client";

/**
 * Proveedores globales de la aplicación.
 *
 * El cliente se crea con `useState` para que sea estable entre renders: si se
 * creara en el cuerpo del componente, cada render tiraría la cache entera.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
